

import { createContext } from "react";

export const BasketContext = createContext({
  count: 0,
  TotalPrice: 0,
  BasketItemList: [],
  basketRef: null,
  setCount: () => {},
  SetBasketItemList: () => {},
  SetTotalPrice: () => {},
});